import React from 'react';
import { RenderNode } from '@contentful/rich-text-react-renderer';
import { Block, BLOCKS, INLINES, Inline } from '@contentful/rich-text-types';

import { Layout, Column } from '../../../Layout';
import RichText from '../../../RichText';
import { EmbeddedInlineEntryNode } from '../../../RichText/Nodes';

import { ParagraphWithLineBreaks } from '../../../RichText/styles';

import { InlineAnchor } from './styles';

export function PageFootnotes(data: any) {
  const RICH_TEXT_OVERRIDE: RenderNode = {
    [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => {
      return (
        <ParagraphWithLineBreaks
          as="p"
          fontSize={{
            0: '2xs',
            tablet: 's'
          }}
          fontWeight="400"
          colour="footerTextSecondary"
        >
          {children}
        </ParagraphWithLineBreaks>
      );
    },
    [INLINES.HYPERLINK]: (node, children) => (
      <InlineAnchor
        href={node.data.uri}
        colour="footerTextSecondary"
        fontWeight="400"
      >
        {children}
      </InlineAnchor>
    ),
    [INLINES.EMBEDDED_ENTRY]: (node, children) => (
      <EmbeddedInlineEntryNode
        node={node}
        colour="footerTextSecondary"
        fontWeight="400"
      >
        {children}
      </EmbeddedInlineEntryNode>
    )
  };

  return (
    <Layout data-testid="page-footnotes">
      <Column size={12} flexDirection="column">
        <RichText
          colour="footerTextSecondary"
          data={data}
          overrideOptions={RICH_TEXT_OVERRIDE}
        />
      </Column>
    </Layout>
  );
}
